export default {
    expanded_wolbachia_1: 'No Wolbachia',
    expanded_wolbachia_2: 'Mean',
    expanded_wolbachia_3: 'Low',
    expanded_wolbachia_4: 'High',
};
